import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_LEADS_ROUTE } from "./Leads.path";
import { ALLOWED_MODULES, MODULES_UUIDS } from "../../constants/enums";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";

const Leads = Loadable(
  lazy(() =>
    import("./Leads").then(({ Leads }) => ({
      default: Leads,
    }))
  )
);

const DeleteLead = Loadable(
  lazy(() =>
    import("./components/LeadRecoveryTable").then(({ RecoveryLeads }) => ({
      default: RecoveryLeads,
    }))
  )
);

const ManageLead = Loadable(
  lazy(() =>
    import("./ManageLead").then(({ ManageLead }) => ({
      default: ManageLead,
    }))
  )
);

export const leadRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.leads.EventLeads,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.LEADS]}>
        <Leads />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${REACT_APP_NAV_ROUTES.leads.EventLeads}/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.LEADS]}>
        <ManageLead moduleUuid={[MODULES_UUIDS.LEADS]} />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${REACT_APP_NAV_ROUTES.leads.EventLeads}/manage/:uuid/:tab?`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.LEADS]}>
        <ManageLead moduleUuid={[MODULES_UUIDS.LEADS]} />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/deleted-leads`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleIds={[]}>
        <DeleteLead />
      </AuthorizedRoute>
    ),
  },
];
